
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec6a0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec6a0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("awTFk", function(module, exports) {

$parcel$export(module.exports, "register", () => $7aa812910441b77c$export$6503ec6e8aabbaf, (v) => $7aa812910441b77c$export$6503ec6e8aabbaf = v);
var $7aa812910441b77c$export$6503ec6e8aabbaf;
var $7aa812910441b77c$export$f7ad0328861e2f03;
"use strict";
var $7aa812910441b77c$var$mapping = new Map();
function $7aa812910441b77c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$7aa812910441b77c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $7aa812910441b77c$var$resolve(id) {
    var resolved = $7aa812910441b77c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$7aa812910441b77c$export$6503ec6e8aabbaf = $7aa812910441b77c$var$register;
$7aa812910441b77c$export$f7ad0328861e2f03 = $7aa812910441b77c$var$resolve;

});

var $0c45e86c8d69c8fb$exports = {};

(parcelRequire("awTFk")).register(new URL("", import.meta.url).toString(), JSON.parse('["fzFkW","index.bbfd1f94.js","9ubBU","sw.js"]'));

var $54b47fc030b7b21e$exports = {};
// Constants:
const $1b952d1406bf4379$var$POLAR_EARTH_RADIUS = 6356752.3142;
const $1b952d1406bf4379$var$PI = Math.PI;
const $1b952d1406bf4379$var$MAX_UINT4 = 4294967295;
const $1b952d1406bf4379$var$FT2M = 1 / 3.2808399 // factor for feet to meter conversions
;
const $1b952d1406bf4379$var$KN2KM = 1 / 1.852 // factor for knots to km conversions
;
// Datatypes:
// ===================================================================================================
// Type    Definition                                          Directive for Ruby's String#unpack
// ---------------------------------------------------------------------------------------------------
// byte 	 UInt8  (16-bit unsigned int)                                      C
// short  UInt16LE  (16-bit unsigned int,littleEndian)                         v
// int 	  UInt32LE  (32-bit unsigned int,littleEndian)                         V
// float   FloatLE  (32 bits IEEE 754 floating point number,littleEndian)      e
// flags  UInt16LE  (16-bit unsigned int,littleEndian)                         v
// ---------------------------------------------------------------------------------------------------
const $1b952d1406bf4379$var$typeReaderFunctions = {
    "UInt8": (dataView, offset)=>dataView.getUint8(offset, false),
    "UInt16LE": (dataView, offset)=>dataView.getUint16(offset, true),
    "UInt32LE": (dataView, offset)=>dataView.getUint32(offset, true),
    "FloatLE": (dataView, offset)=>dataView.getFloat32(offset, true)
} //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
;
// Available block attributes, their offset inside each block and their type:
let $1b952d1406bf4379$var$block_def = {
    "blockSize": {
        "offset": 26,
        "type": "UInt16LE",
        "len": 2
    },
    "lastBlockSize": {
        "offset": 28,
        "type": "UInt16LE",
        "len": 2
    },
    "channel": {
        "offset": 30,
        "type": "UInt16LE",
        "len": 2
    },
    "packetSize": {
        "offset": 32,
        "type": "UInt16LE",
        "len": 2
    },
    "frameIndex": {
        "offset": 34,
        "type": "UInt32LE",
        "len": 4
    },
    "upperLimit": {
        "offset": 38,
        "type": "FloatLE",
        "len": 4
    },
    "lowerLimit": {
        "offset": 42,
        "type": "FloatLE",
        "len": 4
    },
    "frequency": {
        "offset": 51,
        "type": "UInt8",
        "len": 1
    },
    "time1": {
        "offset": 58,
        "type": "UInt16LE",
        "len": 4
    },
    "waterDepthFt": {
        "offset": 62,
        "type": "FloatLE",
        "len": 4
    },
    "keelDepthFt": {
        "offset": 66,
        "type": "FloatLE",
        "len": 4
    },
    "speedGpsKnots": {
        "offset": 98,
        "type": "FloatLE",
        "len": 4
    },
    "temperature": {
        "offset": 102,
        "type": "FloatLE",
        "len": 4
    },
    "raw_lowrance_longitude": {
        "offset": 106,
        "type": "UInt32LE",
        "len": 4
    },
    "raw_lowrance_latitude": {
        "offset": 110,
        "type": "UInt32LE",
        "len": 4
    },
    "speedWaterKnots": {
        "offset": 114,
        "type": "FloatLE",
        "len": 4
    },
    "courseOverGround": {
        "offset": 118,
        "type": "FloatLE",
        "len": 4
    },
    "altitudeFt": {
        "offset": 122,
        "type": "FloatLE",
        "len": 4
    },
    "heading": {
        "offset": 126,
        "type": "FloatLE",
        "len": 4
    },
    "flags": {
        "offset": 130,
        "type": "UInt16LE",
        "len": 2
    },
    "time": {
        "offset": 138,
        "type": "UInt32LE",
        "len": 4
    } // unknown resolution, unknown epoche
};
function $1b952d1406bf4379$var$readBlock(dataView, block_offset) {
    let output = {};
    for(const key in $1b952d1406bf4379$var$block_def)if (Object.hasOwnProperty.call($1b952d1406bf4379$var$block_def, key)) {
        const value_byte_offset = block_offset + $1b952d1406bf4379$var$block_def[key].offset;
        const length = $1b952d1406bf4379$var$block_def[key].len;
        const type = $1b952d1406bf4379$var$block_def[key].type;
        const typeReader = $1b952d1406bf4379$var$typeReaderFunctions[type];
        output[key] = typeReader(dataView, value_byte_offset);
    // console.log(`${key} is ${value_byte_offset}`)
    }
    return output;
}
function $1b952d1406bf4379$var$getLinebreak() {
    if (navigator.userAgent.indexOf("Windows") != -1) return "\r\n";
    else return "\n";
}
async function $1b952d1406bf4379$var$convert_sl2(sl2_file_buffer, progress_callback) {
    let alive_counter = 0 // counter to regularly show, that the script is still running
    ;
    let output_rows = [];
    let block_offset = 0;
    block_offset += 10 // Startindex of the first block (i.e. skip the 10 Bytes of Header)
    ;
    const dataView = new DataView(sl2_file_buffer, 0);
    const sl2_file_size = dataView.byteLength;
    console.log(sl2_file_size, block_offset);
    var starting_laurence_latitude = null, starting_lowrance_longitude = null;
    while(block_offset < sl2_file_size){
        if (alive_counter % 500 == 0) {
            var percent = 100.0 * block_offset / sl2_file_size;
            await progress_callback(Math.round(percent));
        }
        alive_counter += 1;
        let outputRow = $1b952d1406bf4379$var$readBlock(dataView, block_offset);
        // A few conversions into non-proprietary or metric formats:
        // =========================================================
        if (outputRow["raw_lowrance_latitude"] != undefined) {
            outputRow["latitude"] = (2 * Math.atan(Math.exp(outputRow["raw_lowrance_latitude"] / $1b952d1406bf4379$var$POLAR_EARTH_RADIUS)) - $1b952d1406bf4379$var$PI / 2) * (180 / $1b952d1406bf4379$var$PI);
            // Calculate the displacement of the current point from the starting point using the raw laurence lat values:
            if (starting_laurence_latitude == null) starting_laurence_latitude = outputRow["raw_lowrance_latitude"];
            outputRow["y_displacement"] = outputRow["raw_lowrance_latitude"] - starting_laurence_latitude;
        }
        if (outputRow["raw_lowrance_longitude"] != undefined) {
            outputRow["longitude"] = outputRow["raw_lowrance_longitude"] / $1b952d1406bf4379$var$POLAR_EARTH_RADIUS * (180 / $1b952d1406bf4379$var$PI);
            // [ Caution! ] If the expected longitude (in decimal degrees) is *negative*, use the following line instead:
            if (outputRow["longitude"] > 180) outputRow["longitude"] = (outputRow["raw_lowrance_longitude"] - $1b952d1406bf4379$var$MAX_UINT4) / $1b952d1406bf4379$var$POLAR_EARTH_RADIUS * (180 / $1b952d1406bf4379$var$PI);
            // Calculate the displacement of the current point from the starting point using the raw laurence lon values:
            if (starting_lowrance_longitude == null) starting_lowrance_longitude = outputRow["raw_lowrance_longitude"];
            outputRow["x_displacement"] = outputRow["raw_lowrance_longitude"] - starting_lowrance_longitude;
        }
        if (outputRow["waterDepthFt"] != undefined) {
            outputRow["waterDepthFt"] *= -1;
            outputRow["waterDepthM"] = outputRow["waterDepthFt"] * $1b952d1406bf4379$var$FT2M;
        }
        if (outputRow["keelDepthFt"] != undefined) {
            outputRow["keelDepthFt"] *= -1;
            outputRow["keelDepthM"] = outputRow["keelDepthFt"] * $1b952d1406bf4379$var$FT2M;
        }
        if (outputRow["altitudeFt"] != undefined) outputRow["altitudeM"] = outputRow["altitudeFt"] * $1b952d1406bf4379$var$FT2M;
        if (outputRow["speedGpsKnots"] != undefined) outputRow["speedGpsKm"] = outputRow["speedGpsKnots"] * $1b952d1406bf4379$var$KN2KM;
        // console.log("Read block:", outputRow)
        if (outputRow["blockSize"] == 0) {
            alert("ABORTING! (sl2 file may be corrupt): blockSize = 0 found which will otherwise lead to endless loop.");
            break;
        }
        block_offset += outputRow["blockSize"];
        // // Save only one set of data per GPS position to csv-file:
        // unless output_h[[h['latitude'], h['longitude']]]
        // output_h[[h['latitude'], h['longitude']]] = h['waterDepthM']
        output_rows.push(outputRow);
    }
    // When finished, output some statistics:
    console.log("Found and decoded " + output_rows.length + "data blocks.");
    return output_rows;
}
var $1b952d1406bf4379$export$2e2bcd8739ae039 = $1b952d1406bf4379$var$convert_sl2;


var $bcfa223af1a5e435$exports = {};
//download.js v4.21, by dandavis; 2008-2018. [MIT] see http://danml.com/download.html for tests/usage
(function(root, factory) {
    typeof define == "function" && define.amd ? define([], factory) : $bcfa223af1a5e435$exports = factory();
})($bcfa223af1a5e435$exports, function() {
    return function download(data, strFileName, strMimeType) {
        var self = window, defaultMime = "application/octet-stream", mimeType = strMimeType || defaultMime, payload = data, url = !strFileName && !strMimeType && payload, anchor = document.createElement("a"), toString = function(a) {
            return String(a);
        }, myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString, fileName = strFileName || "download", blob, reader;
        myBlob = myBlob.call ? myBlob.bind(self) : Blob, String(this) === "true" && (payload = [
            payload,
            mimeType
        ], mimeType = payload[0], payload = payload[1]);
        if (url && url.length < 2048) {
            fileName = url.split("/").pop().split("?")[0], anchor.href = url;
            if (anchor.href.indexOf(url) !== -1) {
                var ajax = new XMLHttpRequest;
                return ajax.open("GET", url, !0), ajax.responseType = "blob", ajax.onload = function(e) {
                    download(e.target.response, fileName, defaultMime);
                }, setTimeout(function() {
                    ajax.send();
                }, 0), ajax;
            }
        }
        if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
            if (!(payload.length > 2096103.424 && myBlob !== toString)) return navigator.msSaveBlob ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload);
            payload = dataUrlToBlob(payload), mimeType = payload.type || defaultMime;
        } else if (/([\x80-\xff])/.test(payload)) {
            var i = 0, tempUiArr = new Uint8Array(payload.length), mx = tempUiArr.length;
            for(i; i < mx; ++i)tempUiArr[i] = payload.charCodeAt(i);
            payload = new myBlob([
                tempUiArr
            ], {
                type: mimeType
            });
        }
        blob = payload instanceof myBlob ? payload : new myBlob([
            payload
        ], {
            type: mimeType
        });
        function dataUrlToBlob(strUrl) {
            var parts = strUrl.split(/[:;,]/), type = parts[1], indexDecoder = strUrl.indexOf("charset") > 0 ? 3 : 2, decoder = parts[indexDecoder] == "base64" ? atob : decodeURIComponent, binData = decoder(parts.pop()), mx = binData.length, i = 0, uiArr = new Uint8Array(mx);
            for(i; i < mx; ++i)uiArr[i] = binData.charCodeAt(i);
            return new myBlob([
                uiArr
            ], {
                type: type
            });
        }
        function saver(url, winMode) {
            if ("download" in anchor) return anchor.href = url, anchor.setAttribute("download", fileName), anchor.className = "download-js-link", anchor.innerHTML = "downloading...", anchor.style.display = "none", anchor.addEventListener("click", function(e) {
                e.stopPropagation(), this.removeEventListener("click", arguments.callee);
            }), document.body.appendChild(anchor), setTimeout(function() {
                anchor.click(), document.body.removeChild(anchor), winMode === !0 && setTimeout(function() {
                    self.URL.revokeObjectURL(anchor.href);
                }, 250);
            }, 66), !0;
            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) return /^data:/.test(url) && (url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime)), window.open(url) || confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.") && (location.href = url), !0;
            var f = document.createElement("iframe");
            document.body.appendChild(f), !winMode && /^data:/.test(url) && (url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime)), f.src = url, setTimeout(function() {
                document.body.removeChild(f);
            }, 333);
        }
        if (navigator.msSaveBlob) return navigator.msSaveBlob(blob, fileName);
        if (self.URL) saver(self.URL.createObjectURL(blob), !0);
        else {
            if (typeof blob == "string" || blob.constructor === toString) try {
                return saver("data:" + mimeType + ";base64," + self.btoa(blob));
            } catch (y) {
                return saver("data:" + mimeType + "," + encodeURIComponent(blob));
            }
            reader = new FileReader, reader.onload = function(e) {
                saver(this.result);
            }, reader.readAsDataURL(blob);
        }
        return !0;
    };
});


const $660c6262632810ec$var$d = document;
class $660c6262632810ec$export$2e2bcd8739ae039 {
    constructor(element, options = {}, defaults = {}){
        this.options = Object.assign({}, defaults, options);
        this._events = [];
        this.dom = {
            el: this._setElement(element)
        };
    }
    /**
     * Add/remove the toggling className
     * @param {Boolean|undefined} show
     * @return DomComponent
     */ toggle(show) {
        let classList = this.dom.el.classList;
        if (show !== undefined) {
            classList[show ? "remove" : "add"]("si-off");
            return this;
        }
        classList.toggle("si-off");
        return this;
    }
    /**
     * Bind a (delegated) event
     * @param {String} event
     * @param {Function} fn
     * @param {HTMLElement|Document} el
     * @return DomComponent
     */ on(event, fn, el = null) {
        (el || this.dom.el).addEventListener(event, fn = fn.bind(this), true);
        this._events.push({
            name: event,
            fn: fn,
            el: el
        });
        return this;
    }
    /**
     * Return the main wrapping element
     * @return {Element}
     */ getElement() {
        return this.dom.el;
    }
    /**
     * Unbind all events and nullify references
     * @return void
     */ remove() {
        this._events = this._events.filter((event)=>{
            return (event.el || this.dom.el).removeEventListener(event.name, event.fn, true);
        });
        this.dom.el.parentNode.removeChild(this.dom.el);
        this.dom = this.options = null;
    }
    /**
     * Query the element in the DOM if its a string
     * @param {Element|String} el
     * @return {Element|null}
     * @protected
     */ _setElement(el) {
        if (!el && !el.nodeType && typeof el !== "string") throw new Error("Wrong element type provided!");
        if (el.nodeType) return el;
        return (this.options.parent || $660c6262632810ec$var$d).querySelector(el);
    }
    /**
     * Communicate changes
     * @param {String} name
     * @param {Object|null} detail
     * @protected
     */ _trigger(name, detail = null) {
        let event;
        if (typeof CustomEvent === "function") event = new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            cancelable: true
        });
        else {
            event = $660c6262632810ec$var$d.createEvent("CustomEvent");
            event.initCustomEvent(name, true, true, detail);
        }
        this.dom.el.dispatchEvent(event);
    }
}


var $f25299528f89fc0f$export$2e2bcd8739ae039 = {
    items: [],
    display: "value",
    current: null,
    parent: null,
    maxHeight: 0,
    sort: true,
    order: "desc",
    placeholder: "Select items",
    more: "(+{X} more)"
};


const $e32e28c64e9a35f5$var$d = document;
class $e32e28c64e9a35f5$export$2e2bcd8739ae039 extends (0, $660c6262632810ec$export$2e2bcd8739ae039) {
    constructor(element, options = {}){
        super(element, options, (0, $f25299528f89fc0f$export$2e2bcd8739ae039));
        if (this.options.sort) this.options.items = this._sortItems(options.items);
        this.options.items = options.items && options.items.length ? this._convertItems(options.items) : [];
        if (options.current && options.current.length) {
            options.current = this._convertItems(options.current);
            this._setSelected(options.current);
        }
        this._renderInit();
        this._setResultMessage();
        this._bindEvents();
    }
    /**
     * Bind the delegated dom events
     * @private
     */ _bindEvents() {
        // Select or just unfold the options
        this.on("click", (e)=>{
            if (e.target.classList.contains("si-item")) return this._setCurrent(e)._setResultMessage();
            this.toggle();
        }, this.el);
        // Close the dropdown if the user click outside of it
        this.on("click", (e)=>{
            if (!this.dom.el.contains(e.target)) return this.toggle(false);
        }, $e32e28c64e9a35f5$var$d);
        // Fold up the dropdown if the user presses the Escape key
        this.on("keyup", (e)=>{
            if (e.key === "Escape" || e.keyCode === 27) this.toggle(false);
        }, $e32e28c64e9a35f5$var$d);
    }
    /**
     * Get all items in the list
     * @return {Object[]}
     * @public
     */ getItems() {
        return Array.from(this.options.items.values());
    }
    /**
     * Return the current field value object
     * @param {string} key Only return a specific value from each current item
     * @return {[]|null}
     * @public
     */ getCurrent(key = "") {
        let items = this.getItems().filter((i)=>i.selected);
        return !key ? items : items.map((i)=>i[key]);
    }
    /**
     * @todo do better: setCurrent, _setCurrent & _setSelected ...
     * @param {*|!object} currents
     * @public
     */ setCurrent(currents) {
        const isArray = Array.isArray(currents);
        if (!currents || isArray && !currents.length) return;
        let items = this.options.items, display = this.options.display;
        currents = isArray ? currents : [
            currents
        ];
        currents = this._convertItems(currents);
        currents.forEach((current)=>{
            items.forEach((item, key)=>{
                if (item[display] === current[display]) {
                    this.dom.el.querySelector(`.si-item[data-key="${key}"]`).classList.add("si-selected");
                    item.selected = true;
                }
            });
        });
        this._setResultMessage();
    }
    /**
     * Find an item in the list
     * @param {HTMLElement|String|Number} item
     * @return {{}}
     * @public
     */ findItem(item) {
        let display = this.options.display;
        item = item.nodeName ? item.dataset.value : item;
        return this.options.items.find((i)=>i[display] === item);
    }
    /**
     *
     * @param {Event} e
     * @param {boolean} trigger
     * @private
     */ _setCurrent(e, trigger = true) {
        let el = e.target, key = parseInt(el.dataset.key, 10), item = this.options.items.get(key);
        item.selected = el.classList.toggle("si-selected");
        this.options.items.set(key, item);
        if (trigger) this._trigger("change", item);
        return this;
    }
    /**
     * Loop over the passed array to set selected items
     * @param {array} currents
     * @private
     */ _setSelected(currents) {
        let items = this.options.items, display = this.options.display;
        currents.forEach((current)=>{
            items.forEach((item)=>{
                if (item[display] === current[display]) item.selected = true;
            });
        });
    }
    /**
     * Display selection result message
     * @private
     */ _setResultMessage() {
        let selection = this.getCurrent(), display = this.options.display, count = selection.length, result = "";
        switch(count){
            case 1:
                result = selection[0][display];
                break;
            case 0:
                result = this.options.placeholder;
                break;
            default:
                result = /({X})/.test(this.options.more) ? `${selection[0][display]} ${this.options.more.replace("{X}", count - 1)}` : this.options.more;
        }
        this.dom.result.classList[count ? "add" : "remove"]("si-selection");
        this.dom.result.innerHTML = result;
    }
    /**
     * Make an array of object if needed
     * @todo better 'selected' checking: what if `current` is array of objects
     * @param {Array} items
     * @return {Map<Object>}
     * @private
     */ _convertItems(items = []) {
        let display = this.options.display, map = new Map(), key = 0;
        items.forEach((item)=>{
            if (typeof item !== "object") item = {
                [display]: item
            };
            map.set(key++, item);
        });
        return map;
    }
    /**
     * Create the HTML upon instantiation
     * @return {Node}
     * @private
     */ _renderInit() {
        let frag = $e32e28c64e9a35f5$var$d.createDocumentFragment();
        this.dom.el.classList.add("si-off", "si-wrap");
        this.dom.result = frag.appendChild(this._renderResultDiv());
        frag.appendChild(this._renderList());
        return this.dom.el.appendChild(frag);
    }
    /**
     * Create the selection result element
     * @return {HTMLElement}
     * @private
     */ _renderResultDiv() {
        let el = $e32e28c64e9a35f5$var$d.createElement("div");
        el.className = "si-result";
        return el;
    }
    /**
     * Create the list element
     * @return {HTMLElement}
     * @private
     */ _renderList() {
        let wrap = $e32e28c64e9a35f5$var$d.createElement("div"), el = $e32e28c64e9a35f5$var$d.createElement("ul"), maxHeight = this.options.maxHeight;
        wrap.className = "si-list";
        if (maxHeight) wrap.style.maxHeight = maxHeight + "px";
        el.innerHTML = this._renderListItems();
        wrap.appendChild(el);
        return wrap;
    }
    /**
     * Create the list items
     * @return {String}
     * @private
     */ _renderListItems() {
        let items = this.options.items, display = this.options.display, list = "", selected;
        items.forEach((item, key)=>{
            selected = item.selected ? " si-selected" : "";
            list += `<li class="si-item${selected}" data-key="${key}">${item[display]}</li>`;
        });
        return list;
    }
    /**
     * Rearrange the list
     * @private
     */ _sortItems() {
        let order = this.options.order === "desc" ? 1 : -1, display = this.options.display;
        this.options.items.sort((a, b)=>{
            if (a[display] < b[display]) return -order;
            if (a[display] > b[display]) return order;
            return 0;
        });
    }
}


var $01ae5ab63191e17f$exports = {};
$01ae5ab63191e17f$exports = new URL("sw.js", import.meta.url).toString();


// Register service worker to control making site work offline
if ("serviceWorker" in navigator) navigator.serviceWorker.register($01ae5ab63191e17f$exports).then(()=>{
    console.log("Service Worker Registered");
});
window.addEventListener("load", function() {
    console.log("Page loaded");
    const inputElement = document.getElementById("input");
    inputElement.addEventListener("change", $54b47fc030b7b21e$var$handleFiles, false);
});
function $54b47fc030b7b21e$var$setMessage(message) {
    document.getElementById("message").innerHTML = message;
}
function $54b47fc030b7b21e$var$getLinebreak() {
    if (navigator.userAgent.indexOf("Windows") != -1) return "\r\n";
    return "\n";
}
var $54b47fc030b7b21e$var$columnSelector;
function $54b47fc030b7b21e$var$addColumnSelctionPicker(resultObject) {
    // var selectParent = document.getElementById("Column_Selector")
    var options = [];
    for(var key in resultObject[0])options.push(key);
    $54b47fc030b7b21e$var$columnSelector = new (0, $e32e28c64e9a35f5$export$2e2bcd8739ae039)("#Column_Selector", {
        items: options,
        current: [
            "latitude",
            "longitude",
            "waterDepthM"
        ],
        sort: false,
        placeholder: "Select columns to include"
    });
}
// function getSelectValues(selectElem) {
//     var result = [];
//     var options = selectElem && selectElem.options;
//     var opt;
//     for (var i = 0, iLen = options.length; i < iLen; i++) {
//         opt = options[i];
//         if (opt.selected) {
//             result.push(opt.value || opt.text);
//         }
//     }
//     return result;
// }
function $54b47fc030b7b21e$var$getSelectedColumns() {
    // var select = document.getElementById("mySelect")
    var selectedOptions = $54b47fc030b7b21e$var$columnSelector.getCurrent();
    var result = {};
    for(var i = 0; i < selectedOptions.length; i++)result[selectedOptions[i].value] = true;
    return result;
}
function $54b47fc030b7b21e$var$resultToCSV(resultObject, columsToInclude) {
    let columns = Object.keys(resultObject[0]).filter((rowName)=>{
        return columsToInclude[rowName] == true;
    });
    let output_csv_string = columns.join(",") + $54b47fc030b7b21e$var$getLinebreak();
    // Finally every row is written to the csv string:
    for(var i = 0; i < resultObject.length; i++)output_csv_string += Object.keys(resultObject[i]).filter((rowName)=>{
        return columsToInclude[rowName] == true;
    }).map((keyName)=>{
        return resultObject[i][keyName].toString();
    }).join(",") + $54b47fc030b7b21e$var$getLinebreak();
    return output_csv_string;
}
function $54b47fc030b7b21e$var$resultToKML(resultObject) {
    let output_kml_string = `<?xml version="1.0" encoding="UTF-8"?>
    <kml xmlns="http://www.opengis.net/kml/2.2">
    <Document>
      <name>SonarConverted.kml</name>
      <open>1</open>
      <Placemark>
        <name>SonarPath</name>
        <LineString>
          <extrude>1</extrude>
          <tessellate>1</tessellate>
          <altitudeMode>relativeToGround</altitudeMode>
          <coordinates>
          `;
    // every row is written to the kml string:
    for(var i = 0; i < resultObject.length; i++)output_kml_string += [
        "longitude",
        "latitude",
        "waterDepthM"
    ].map((keyName)=>{
        // if (keyName == "waterDepthM") resultObject[i][keyName] *= -1;
        return resultObject[i][keyName].toString();
    }).join(",") + ` `; // space char
    output_kml_string += `
                </coordinates>
            </LineString>
        </Placemark>
    </Document>
    </kml>
    `;
    return output_kml_string;
}
function $54b47fc030b7b21e$var$handleFiles(evt) {
    var files = evt.target.files;
    var file = files[0];
    function downloadCSV(string) {
        (0, (/*@__PURE__*/$parcel$interopDefault($bcfa223af1a5e435$exports)))(string, file.name + "_converted.csv", "text/csv");
    }
    function downloadKML(string) {
        (0, (/*@__PURE__*/$parcel$interopDefault($bcfa223af1a5e435$exports)))(string, file.name + "_converted.kml", "application/vnd.google-earth.kml+xml");
    }
    function conversionCompleteHandler(output) {
        $54b47fc030b7b21e$var$setMessage("Done!");
        $54b47fc030b7b21e$var$addColumnSelctionPicker(output);
        var button = document.getElementById("download_button");
        button.parentNode.style.display = "block";
        button.onclick = function() {
            var output_format = document.getElementById("Output_Format").value;
            // if csv is the selected format:
            if (output_format == "csv") downloadCSV($54b47fc030b7b21e$var$resultToCSV(output, $54b47fc030b7b21e$var$getSelectedColumns()));
            else if (output_format == "kml") downloadKML($54b47fc030b7b21e$var$resultToKML(output));
        };
    }
    var jsFileReader = new FileReader();
    jsFileReader.onload = function(event) {
        var file_contents = event.target.result;
        console.log("Loaded file: ", file_contents);
        document.getElementById("Info_Text").style.display = "none";
        document.getElementById("input").disabled = "true";
        var message_el = document.getElementById("message");
        var progress_el = document.getElementById("progress-bar");
        message_el.innerHTML = "Converting... (May make page unresponsive)";
        progress_el.style.display = "block";
        setTimeout(function() {
            (0, $1b952d1406bf4379$export$2e2bcd8739ae039)(file_contents, async (percent_done)=>{
                message_el.innerHTML = `Converting... ${percent_done}% done`;
                progress_el.value = percent_done / 100.0;
                await new Promise((r)=>setTimeout(r, 0));
            }).then((output)=>{
                progress_el.style.display = "none";
                conversionCompleteHandler(output);
            }).catch((error)=>{
                console.error("Conversion failed: ", error);
                progress_el.style.display = "none";
                message_el.innerHTML = "Conversion failed. Please reload the page and try again.";
            });
        }, 1);
    };
    jsFileReader.readAsArrayBuffer(file);
}
$54b47fc030b7b21e$exports = {};


//# sourceMappingURL=index.bbfd1f94.js.map
